import AppToast from "./AppToast";
import ClinicNavigation from "@features/clinics/components/ClinicNavigation";
import ClinicTopBar from "@features/clinics/components/ClinicTopBar";
import React, { ReactNode, useCallback, useState } from "react";
import UserNavigation from "@features/user/components/UserNavigation";
import UserTopBar from "@features/user/components/UserTopBar";
import EventNavigation from "@features/events/components/EventNavigation";
import EventTopBar from "@features/events/components/EventTopBar";
import { Frame } from "@medentic/polaris-react";
import { PageTypes } from "@shared/types/commonTypes";
import { RootState } from "@app/store/store";
import { useSelector } from "react-redux";
import logoLight from "@shared/assets/logo_light.svg";

interface AppFrameProps {
  headerType?: PageTypes | null;
  children: ReactNode;
}

const AppFrame: React.FC<AppFrameProps> = ({ headerType = null, children }) => {
  const [showMobileNavigation, setShowMobileNavigation] = useState(false);
  const isAppLoading = useSelector(
    (state: RootState) => state.app.isInitializingApp
  );

  const toggleMobileNavigation = useCallback(() => {
    setShowMobileNavigation((prevState) => !prevState);
  }, []);

  const logo = {
    width: 124,
    topBarSource: logoLight,
    accessibilityLabel: "Medentic",
  };

  let navigation;
  let topBar;

  switch (headerType) {
    case PageTypes.USER:
      navigation = <UserNavigation />;
      topBar = <UserTopBar onNavigationToggle={toggleMobileNavigation} />;
      break;
    case PageTypes.CLINIC:
      navigation = <ClinicNavigation />;
      topBar = <ClinicTopBar onNavigationToggle={toggleMobileNavigation} />;
      break;
    case PageTypes.PATIENT:
      // TODO: have to make separate nav and topbar for patient
      navigation = undefined;
      topBar = <UserTopBar onNavigationToggle={toggleMobileNavigation} />;
      break;
    case PageTypes.EVENT:
      navigation = <EventNavigation />;
      topBar = <EventTopBar onNavigationToggle={toggleMobileNavigation} />;
      break;
    default:
      navigation = undefined;
      topBar = undefined;
      break;
  }

  const hideTopNav = headerType === null || isAppLoading;

  return (
    <Frame
      logo={hideTopNav ? undefined : logo}
      navigation={hideTopNav ? undefined : navigation}
      topBar={hideTopNav ? undefined : topBar}
      showMobileNavigation={hideTopNav ? false : showMobileNavigation}
      onNavigationDismiss={toggleMobileNavigation}
    >
      <AppToast />
      {children}
    </Frame>
  );
};

export default AppFrame;
